const neonNavItems = [
  { to: '/neon', label: 'Levels' },
];

export default neonNavItems;
